import propTypes from 'prop-types'

const HexNumberPropTypes = {
  number: propTypes.string,
}

const HexNumberDefaultProps = {
  number: 1,
}

const HexNumber = props => {
  const { number } = props

  return (
    <svg
      width="24"
      height="27"
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M10.3861 0.91585C11.3872 0.361384 12.6128 0.361383 13.6139 0.91585L18 3.3451L22.346 5.84219C23.338 6.41213 23.9508 7.44925 23.9599 8.57366L24 13.5L23.9599 18.4263C23.9508 19.5508 23.338 20.5879 22.346 21.1578L18 23.6549L13.6139 26.0841C12.6128 26.6386 11.3872 26.6386 10.3861 26.0842L6 23.6549L1.65396 21.1578C0.662001 20.5879 0.0492238 19.5508 0.0400765 18.4263L0 13.5L0.0400765 8.57366C0.0492238 7.44925 0.662 6.41213 1.65396 5.84219L6 3.3451L10.3861 0.91585Z"
          fill="#FFC8B3"
        />
        <text
          x="8"
          y="18"
          fontFamily="Helvetica Neue"
          fontWeight="700"
          fontSize="14"
          fill="#1B1C1B"
        >
          {number}
        </text>
      </g>
    </svg>
  )
}

HexNumber.propTypes = HexNumberPropTypes
HexNumber.defaultProps = HexNumberDefaultProps

export default HexNumber
